module.exports = __webpack_public_path__ + "img/ppls2.da79854b.png";